import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>PolicyPal</h3>
          <p>Your trusted insurance partner for life, health, auto, and home insurance.</p>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#quote">Get Quote</a></li>
            <li><a href="#chatbot">Chat Support</a></li>
            <li><a href="#claims">File Claim</a></li>
            <li><a href="#about">About Us</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Insurance Types</h4>
          <ul>
            <li><a href="#auto">Auto Insurance</a></li>
            <li><a href="#home">Home Insurance</a></li>
            <li><a href="#life">Life Insurance</a></li>
            <li><a href="#health">Health Insurance</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Contact Info</h4>
          <p>📞 1-800-POLICY</p>
          <p>✉️ support@policypal.com</p>
          <p>📍 123 Insurance Ave, City, State 12345</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 PolicyPal. All rights reserved. | Privacy Policy | Terms of Service</p>
      </div>
    </footer>
  );
};

export default Footer;